import KInputText from 'app/components/Modules/Form/KInputText'
import { useKFormContext } from 'app/lib/contexts/KFormContext'
import * as React from 'react'
import { useEffect } from 'react'

type Props = React.ComponentProps<typeof KInputText>

const KReadOnlyInput = ({ value, name, ...others }: Props) => {
  const { form } = useKFormContext()

  useEffect(() => {
    form.setFieldsValue({ [`${name}`]: value })
  }, [value])

  return <KInputText readOnly name={name} {...others} />
}

export default KReadOnlyInput
